import { Button, Text, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import ProfileSelector from "../../ProfileSelector";
import { ProfileProps } from "../types";
import { motion } from "framer-motion";

const LegalFormat: React.FC<ProfileProps> = ({
  data,
  defaultValue: { legal_format_id },
  handleSubmit,
}) => {
  const [optionSelected, setOptionSelected] = useState<string[]>(
    legal_format_id ? [legal_format_id] : []
  );

  return (
    <motion.div
      style={{
        height: "100%",
        margin: 0,
        width: "100%",
        overflow: "auto",
      }}
      initial={{ scale: 0.9 }}
      animate={{ scale: 1 }}
    >
      <VStack height={"100%"} alignItems={"flex-start"}>
        <Text fontFamily={"Raleway"} fontSize={"RH_sm"} fontWeight={600}>
          Qual o formato jurídico da sua empresa?
        </Text>
        <Text color={"Gray.$700"} fontSize={"L_sm"} fontWeight={400}>
          Escolha abaixo o modo como sua empresa foi formalizada
        </Text>

        <VStack
          w={"100%"}
          flex={1}
          alignItems={"flex-start"}
          mt={"32px !important"}
        >
          <ProfileSelector
            data={data}
            idSelecteds={optionSelected}
            onPress={setOptionSelected}
          />
        </VStack>
        <Button
          variant={"Primary"}
          w={"100%"}
          onClick={() => handleSubmit({ legal_format_id: optionSelected[0] })}
          isDisabled={optionSelected.length < 1}
        >
          Continuar
        </Button>
      </VStack>
    </motion.div>
  );
};

export default LegalFormat;
